import { datadogLogs, type LogsEvent } from '@datadog/browser-logs';

import { isLocalhost } from '../../utils/utils';

const QUERY_PARAMS_TO_REDACT = ['access_token', 'id_token', 'code'];

const isFailedHereRequestLog = (event: LogsEvent): boolean =>
    !!event?.http?.url.includes('maps.hereapi.com') || !!event?.http?.url.includes('vector.hereapi.com');

const redactLogEvent = (event: LogsEvent) => {
    QUERY_PARAMS_TO_REDACT.forEach(param => {
        const regex = new RegExp(`${param}=[^&]*`, 'g');
        event.view.url = event.view.url.replace(regex, `${param}=REDACTED`);
        event.view.referrer = event.view.referrer?.replace(regex, `${param}=REDACTED`);
        event.message = event.message?.replace(regex, `${param}=REDACTED`);
        if (event.error?.stack) {
            event.error.stack = event.error.stack.replace(regex, `${param}=REDACTED`);
        }
        if (event.http?.url) {
            event.http.url = event.http.url.replace(regex, `${param}=REDACTED`);
        }
    });
    return true;
};

const cleanLogs = (event: LogsEvent) => {
    if (isFailedHereRequestLog(event)) {
        return false;
    }
    return redactLogEvent(event);
};

if (!isLocalhost()) {
    datadogLogs.init({
        clientToken: 'pubab55d5c84e1d32077444f038c9785650',
        forwardErrorsToLogs: true,
        site: 'datadoghq.eu',
        sessionSampleRate: 100,
        version: '0.6.0',
        service: 'livemonitor-web',
        env: 'prod',
        beforeSend: obj => cleanLogs(obj),
    });
    datadogLogs.setGlobalContextProperty('team_identifier', import.meta.env.VITE_TEAM_IDENTIFIER);
    datadogLogs.setGlobalContextProperty('account_id', import.meta.env.VITE_ACCOUNT_ID);
    datadogLogs.setGlobalContextProperty('account_name', import.meta.env.VITE_ACCOUNT_NAME);
}
